import {Component, Input, ViewEncapsulation} from '@angular/core';
import {PdfDetails} from '../../models/pdf/pdf-details';

@Component({
    selector: 'app-pdf-page-quickscan',
    templateUrl: './pdf-page-quickscan.component.html',
    styleUrls: ['./pdf-page-quickscan.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PdfPageQuickscanComponent {

    @Input() pdfDetails: PdfDetails;

}
